export default __webpack_public_path__ + "assets/images/2e557bf70789f68f295043cafac49f33.png";